import { DashboardOpcButton } from '../../types/app/dashboardOpcButton';
import { api } from '../core/api';

export const getDashboardOpcButtonList = (parentId: number) =>
  api
    .get<DashboardOpcButton[]>(`DashboardOpcButton/GetList?parentId=${parentId}`)
    .then((res) => res.data);

export const getDashboardOpcButton = (id: number) =>
  api.get<DashboardOpcButton>(`DashboardOpcButton/GetItem/?id=${id}`).then((res) => res.data);

export const createOpcButton = (data: any) =>
  api.post(`DashboardOpcButton/CreateItem`, data).then((res) => res.data);

export const performButtonClicked = (data: { id: number; newValue: string }) =>
  api
    .post(
      `DashboardOpcButton/PerformButtonClicked?id=${data.id}${
        data.newValue ? `&newValue=${data.newValue}` : ''
      }`,
      {},
    )
    .then((res) => res.data);

export const updateOpcButton = (data: any) =>
  api.put(`DashboardOpcButton/UpdateItem`, data).then((res) => res.data);

export const deleteOpcButton = (id: number) =>
  api.delete<DashboardOpcButton>(`DashboardOpcButton/DeleteItem/?id=${id}`).then();
